import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Header } from "@/components/aklive/Header";
import { Footer } from "@/components/aklive/Footer";
import { MaskedLines, Reveal } from "@/components/aklive/motion";
import { WorkGallery } from "@/components/aklive/work/WorkGallery";

export default function Work() {
  useEffect(() => {
    document.title = "AKLIVE — Selected Work";
  }, []);

  return (
    <div className="bg-paper text-left text-ink" data-testid="work-page">
      <Header />
      <main id="main" className="overflow-x-clip">
        <section className="pt-28 md:pt-36" data-testid="work-hero">
          <div className="container-ak">
            <h1 className="font-display text-5xl font-bold leading-[0.98] tracking-[-0.02em] text-ink sm:text-6xl lg:text-7xl">
              <MaskedLines
                lines={[
                  <span key="l1">
                    Selected Work<span className="text-ember">.</span>
                  </span>,
                ]}
              />
            </h1>
            <Reveal delay={0.15} className="mt-6 md:mt-8">
              <p className="max-w-[620px] text-base leading-relaxed text-ink2 md:text-lg">
                A collection of identities, websites, campaigns, presentations, packaging and
                experiences created across different industries.
              </p>
            </Reveal>
          </div>
        </section>

        <WorkGallery />

        <section className="py-24 md:py-40" data-testid="work-cta-section">
          <div className="container-ak">
            <h2 className="font-display text-4xl font-bold leading-[1.02] tracking-[-0.02em] text-ink sm:text-5xl lg:text-6xl">
              <MaskedLines
                lines={[
                  "Have something",
                  <span key="l2">
                    worth building<span className="text-ember">?</span>
                  </span>,
                ]}
              />
            </h2>
            <Reveal delay={0.25} className="mt-10 md:mt-12">
              <Link to="/contact" data-testid="work-cta-start-btn" className="btn-primary h-14 px-8 text-base">
                Start a Project
              </Link>
            </Reveal>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
